import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const BeautyAndWellness = () => {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Beauty & Wellness
        </Typography>
        <Typography variant="body1">
          Beauty and wellness products coming soon...
        </Typography>
      </Container>
    </Box>
  );
};

export default BeautyAndWellness;
